import React from 'react';

import WelcomeScreen from '../components/Welcome';
import TermsAndConditions from '../components/TermsAndConditions';

const TermsAndConditionsPage: React.FC = () => {	
	return (
		<div className="min-h-screen bg-primary">
			<WelcomeScreen />
			
			<div className='flex justify-center'>
				<div className='pl-5 pr-5 max-w-4xl'>
					<h1 className="text-2xl font-bold text-white text-center">Terms And Conditions</h1>

					<div className='text-white mb-10'>
						<TermsAndConditions/>
					</div>
				</div>
			</div>
			
		</div>
	);
};

export default TermsAndConditionsPage;